const select = async function() {
    if ( !document.querySelector(".wpcf7-select") ) return;

    try {
        const CustomSelect = await (await import('../utils/custom-select')).default;
        document.querySelectorAll(".wpcf7-select").forEach(select => {
            const customSelect = new CustomSelect(select, {
                label: "Please select",
                value: "none",
                afterElement: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="##1A1A1A"><path d="M480-360 280-560h400L480-360Z"/></svg>',
            })
        })
    } catch (e) {}
}

export const init = select;